// components/Footer.jsx
import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright 2024 Hartnall Digital Solutions. All rights reserved.   ABN: 58 764 846 959&nbsp;</p>
    </footer>
  );
};

export default Footer;